/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Weblog, LoggerConfigByUser } from '@ks/weblogger/lib/log.hybrid';
import Radar from '@ks/weblogger/lib/plugins/radar';
import cookies from 'js-cookie';
import { getAppInfo } from '../bridge';

type LogConfigEnv = LoggerConfigByUser['env'];

const NODE_ENV = process.env.NODE_ENV as LogConfigEnv;

export const getProduct = () => {
  if (/nebula/i.test(navigator?.userAgent)) {
    // 极速版 NEBULA = 13
    return 13;
  }
  if (/Kwai/i.test(navigator?.userAgent)) {
    // 快手主APP KUAISHOU = 1
    return 1;
  }

  return 0;
};

export const getProductName = () => {
  if (/nebula/i.test(navigator?.userAgent)) {
    // 极速版 NEBULA = 13
    return 'NEBULA';
  }
  if (/Kwai/i.test(navigator?.userAgent)) {
    // 快手主APP KUAISHOU = 1
    return 'KUAISHOU';
  }

  return process.env.NODE_ENV === 'production' ? '' : 'KUAISHOU';
};

const logConfig: LoggerConfigByUser = {
  env: NODE_ENV,
  plugins: [
    new Radar({
      // @ts-ignore
      projectId: process.env.VUE_APP_RADAR_PROJECT_ID || '',
      sampling: 1, // 上报采样率，1 为全部上报
    }),
  ],
  logger: true,
};

if (NODE_ENV === 'production') {
  logConfig.logger = false;
}

export class WebLogger {
  // @ts-ignore
  logger: Weblog;

  constructor() {
    this.logger = new Weblog(logConfig, {
      user_id: cookies.get('userId') || cookies.get('ud'),
      global_id: '',
      version_name: cookies.get('appver') || '',
      product: getProduct(),
      product_name: getProductName(),
      channel: cookies.get('c') || '',
      network_type: cookies.get('net') || ('unknown' as any),
    });
    this.updateCurrentUrlPackage = this.logger.updateCurrentUrlPackage.bind(
      this.logger
    );
  }

  // eslint-disable-next-line max-params
  sendImmediately(type: any, option: any) {
    this.logger.sendImmediately(type, option);
  }

  updateCommonPackage(options: any) {
    this.logger.updateCommonPackage(options);
  }

  // 路由变化的时候用
  updateCurrentUrlPackage;
}
